import { render, staticRenderFns } from "./AddContactToRecordForm.vue?vue&type=template&id=001f8210&scoped=true&"
import script from "./AddContactToRecordForm.vue?vue&type=script&lang=js&"
export * from "./AddContactToRecordForm.vue?vue&type=script&lang=js&"
import style0 from "./AddContactToRecordForm.vue?vue&type=style&index=0&id=001f8210&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001f8210",
  null
  
)

export default component.exports